import type { ButtonHTMLAttributes } from "react";

// Verso button. Variants back the .btn classes in components.css:
//   primary — coral call-to-action   ghost — quiet text action
//   danger  — destructive            default — neutral outline
export type ButtonVariant = "default" | "primary" | "ghost" | "danger";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  small?: boolean;
}

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  default: "",
  primary: "btn--primary",
  ghost: "btn--ghost",
  danger: "btn--danger",
};

export function Button({ variant = "default", small, className, type, ...rest }: ButtonProps) {
  const classes = ["btn", VARIANT_CLASS[variant], small ? "btn--small" : "", className]
    .filter(Boolean)
    .join(" ");
  return <button type={type ?? "button"} className={classes} {...rest} />;
}
